<template>
  <div id="profile" class="container">
    <section>
      <div class="section-group">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
              <div class="card-body box-profile">
                <div class="text-center">
                  <avatarVue :src="authorLogo" :size="100"></avatarVue>
                  <!-- <el-avatar :src="authorLogo" :size="100"></el-avatar> -->
                </div>
                <h3 class="profile-username text-center mb-1">
                  {{ authorName }}
                </h3>
                <div style="text-align: center">
                  {{ sortLink }}
                </div>
                <button type="button" class="btn btn-block btn-primary width mt-3" @click="showMsg">
                  {{ $t('Customer.customerPublishLook.msg') }}
                </button>
                <button type="button" class="btn btn-block btn-primary width mt-3" @click="agree()" v-if="addfriendbtn">
                    {{ $t('Customer.customerPublishLook.agree') }}
                  </button>
              </div>
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <div class="col-md-9 pl-md-4">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <ul class="nav nav-pills" v-if="countList != null">
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: isPicture == 0 }" href="javascript:void(0);"
                          @click="showContent(0)" data-toggle="tab"> {{ $t('Customer.customerPublishLook.Photo_album') }}<span class="count">{{
                            this.countList.photoCount
                          }}</span></a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: isPicture == 1 }" href="javascript:void(0);"
                          @click="showContent(1)" data-toggle="tab"> {{ $t('Customer.customerPublishLook.film') }}<span class="count">{{
                            this.countList.videoCount
                          }}</span></a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: isPicture == 2 }" href="javascript:void(0);"
                          @click="showContent(2)" data-toggle="tab"> {{ $t('Customer.customerPublishLook.group') }}<span class="count">{{
                            this.pageParamsGroup.total
                          }}</span></a>
                      </li>
                    </ul>
                  </div>
                  <!-- Search bar -->
                  <div class="col-4">
                    <div class="search">
                      <el-input :placeholder="$t('Customer.customerPublishLook.search')" suffix-icon="fas fa-search" v-model="title"></el-input>
                    </div>
                  </div>
                  <!-- /.Search bar -->
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body" v-show="isPicture === 0">
                <!-- My Profile -->
                <div class="profile-album section-group" v-if="getalbumList">
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerPublishLook.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerPublishLook.No_album') }}</div>
                  </div>
                </div>
                <div class="my-profile section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6 col-md-4 col-lg-3" v-for="album in albumList" :key="album.id">
                          <div class="album-card card">
                            <div :class="{
                              notclick: 9999 == album.sgL_DevicesType,
                            }">
                              <router-link :to="{
                                name: 'albumviewPhotostream',
                                query: { id: album.id },
                              }">
                                <div class="album-block">
                                  <div class="album-thumbnail">
                                    <div class="album-responsive">
                                      <div class="album-sizer">
                                        <div v-if="album.sgL_DevicesType != 9999" class="album-image" :style="{
                                          backgroundImage:
                                            'url(' +
                                            `${album.photoImage}` +
                                            ')',
                                        }"></div>
                                        <div v-else class="album-image" :style="{
                                          backgroundImage:
                                            'url(' +
                                            require('../../assets/images/album/upload-loading.jpg') +
                                            ')',
                                        }"></div>
                                      </div>
                                    </div>
                                    <div class="album-photo-count">
                                      <span>{{
                                        album.sgL_PG_CPhotoQuantityF
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="album-info" style="padding: 10px 1rem 0px 1rem">
                                  <div class="album-title mb-2" :title="album.sgL_PG_CName" style="height: 1rem">
                                    {{ album.sgL_PG_CName }}
                                  </div>
                                </div>
                              </router-link>
                              <div class="album-info" style="padding: 5px 1rem">
                                <div style="word-break: break-all">
                                  {{ getSortLink(album.id) }}
                                </div>
                                <span class="album-upload-date">{{
                                  album.sgL_PG_CAddTimerI
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-5">
                    <div class="col-12 col-sm-6 col-xs-4">
                      <!--  引用分页组件 -->
                      <pagination v-if="getPageShow" :currentPage="pageParams.currentPage" :total="pageParams.total"
                        :limit="pageParams.limit" :small="true" @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange" />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="isPicture === 1">
                <!-- My Profile -->
                <div class="profile-album section-group" v-if="getvideoList">
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerPublishLook.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerPublishLook.No_film') }}</div>
                  </div>
                </div>
                <div class="my-profile section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-4" v-for="video in videoList" :key="video.id">
                          <div class="video-card card">
                            <a :href="`${base.evi}/videowatch/${video.id}/video`">
                              <div class="video-block">
                                <div class="video-thumbnail">
                                  <div class="video-responsive">
                                    <div class="video-sizer">
                                      <div class="video-image" :style="{
                                        backgroundImage:
                                          'url(' +
                                          `${video.imageFileP}` +
    ')',
}"></div>
                                    </div>
                                  </div>
                                  <div class="video-duration">
                                    <span>{{
                                      video.mov_VSourceTimeFormat
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="video-info p-3">
                                <div class="video-title mb-2" :title="video.sgL_Mov_VSubject">
                                  {{ video.sgL_Mov_VSubject }}
                                </div>
                                <span class="video-upload-date">{{
                                  video.sgL_Mov_VAddTimerH
                                }}</span>
                              </div>
                            </a>
                            <div class="actions"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-5">
                    <div class="col-12 col-sm-6 col-xs-4">
                      <!--  引用分页组件 -->
                      <pagination v-if="getPageShowvideo" :currentPage="pageParamsVideo.currentPage"
                        :total="pageParamsVideo.total" :limit="pageParamsVideo.limit" :small="true"
                        @handleCurrentChange="handleCurrentChangevideo" @handleSizeChange="handleSizeChangevideo" />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <div class="card-body" v-show="isPicture === 2">
                <!-- My Profile -->
                <div class="profile-album section-group" v-if="getGroup">
                  <div class="empty-block">
                    <div class="empty-block-inner" v-if="dataList == true">
                       {{ $t('Customer.customerPublishLook.loading') }}...
                    </div>
                    <div class="empty-block-inner" v-else> {{ $t('Customer.customerPublishLook.No_data') }}</div>
                  </div>
                </div>
                <div class="my-profile section-group" v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6 col-md-4 col-lg-3" v-for="item in groupList" :key="item.id">
                          <div class="feedpost-photo-card">
                            <div class="feedpost-block">
                              <div class="grouppublic-thumbnail">
                                <div class="feedpost-responsive">
                                  <a href="javascript:;" @click="entryGroup(item)">
                                    <div class="feedpost-sizer">
                                      <div class="grouppublic-image" :style="{
                                        'background-image': `url(
                                                                                    ${item.sgL_Logo}
                                                                                  )`,
                                      }"></div>
                                    </div>
                                  </a>
                                </div>
                                <p class="grouppublic-title">
                                  {{ item.sgL_GroupName }}
                                </p>
                                <p style="text-align: center">
                                  <input data-toggle="modal" data-target="#groupfriendlist" class="btn btn-primary"
                                    type="submit" :value="$t('Customer.customerPublishLook.Apply')" v-if="isShowApplyBtn(item)" @click="shenqing(item)" />
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-5" style="justify-content: center">
                    <div class="col-12 col-sm-6 col-xs-4">
                      <!--  引用分页组件 -->
                      <pagination v-if="getPageShowGroup" :currentPage="pageParamsGroup.currentPage"
                        :total="pageParamsGroup.total" :limit="pageParamsGroup.limit" :small="true"
                        @handleCurrentChange="handleCurrentChangeGroup" @handleSizeChange="handleSizeChangeGroup" />
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
    </section>
    <div id="private-box" v-if="loginUser">
      <div id="private-message" class="modal fade show" aria-modal="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <button type="button" class="close text-right p-2" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <!-- Input message box -->
            <div class="pri_input_box2">
              <div class="user_icon">
                <img :src="loginUser.userLogoSmail" />
                <p class="user_info">
                  <span class="txt2">{{ loginUser.displayName }}</span>
                </p>
              </div>
              <div class="fm">
                <textarea class="in-box" rows="5" cols="50" id="emoji" :placeholder="$t('Customer.customerPublishLook.placeholder')" v-model="msgText"></textarea>
              </div>
              <div class="btn_fm">
                <button class="btn-send" @click="sendMessage"> {{ $t('Customer.customerPublishLook.sendMessage') }}</button>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    </div>
  </div>
</template>
<script>
import pagination from "../common/Page";
import bases from "../../api/httpApi/base";
import avatarVue from "../common/avatar.vue";
export default {
  data() {
    return {
      msgShow: false,
      msgText: "",
      authorId: 0,
      authorLogo: "",
      authorName: "",

      isPicture: 0,
      floading: true,
      title: null,
      base: null,
      countList: null,
      albumList: null,
      videoList: null,
      dataList: true,
      groupList: null,
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      pageParamsVideo: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      pageParamsGroup: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
        addfriendbtn: true,
    };
  },
  watch: {
    title(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        if (this.isPicture == 0) {
          this.getPicturePublish();
        } else if (this.isPicture == 1) {
          this.getVideoPublish();
        } else if (this.isPicture == 2) {
          this.getGroupList();
        }
      }
    },
  },
  components: {
    pagination,
    avatarVue,
  },
  created() {
    //获取作者数据
    var query = this.$route.query;
    if (query != null) {
      if (query.authorId != null) {
        this.authorId = query.authorId;
      }
      /* if (query.authorName != null) {
        this.authorName = query.authorName;
      }
      if (query.authorLogo != null) {
        this.authorLogo = query.authorLogo;
      } */
    }
    this.base = bases;
    this.getAuthorInfo();
    this.getVideoAndMovieCount();
    this.getPicturePublish();
    this.getGroupList();
    this.isFriends();
  },
  methods: {
      async agree () {
      const { data } = await this.$api.social.FriendsCreate({ sgL_ToUsersId: this.authorId, });
      if (data.success)
        this.$message.success(this.$t('message.operatesuccessfully'));
      else
        this.$message.error(data.error.message);
    },
    async isFriends () {
      const { data } = await this.$api.social.FriendsGetAll({ SkipCount: 1, MaxResultCount: 999, SGL_ToUsersId: this.authorId, });
      this.addfriendbtn = data.result.items.length == 0;
    },
    sendMessage() {
      this.$api.commons
        .AddSocketMessage({
          toUsersId: this.authorId,
          toUsersName: this.authorName,
          content: this.msgText,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message.success("發送成功");
            $("#private-message").modal("hide");
          }
        });
    },
    showMsg() {
      if (this.loginUser) {
        this.msgText = "";
        $("#private-message").modal("show");
      } else {
        this.$router.push({
          name: "customerLogin",
          query: {
            redirect: this.$router.currentRoute.fullPath,
          },
        });
      }
    },
    entryGroup(item) {
      if (!this.loginUser) {
        this.$router.push({
          path: "/customerLogin",
          query: { redirect: this.$route.fullPath },
        });
        return;
      }
      const isEntry = this.isShowApplyBtn(item);
      if (!isEntry) {
        let routeData = this.$router.resolve({
          name: "feedGroup_FeedGroupDetail",
          query: {
            sgL_GroupId: item.id,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    isShowApplyBtn(item) {
      if (!this.loginUser) {
        return false;
      } else {
        //判断是否已经进群
        if (item.inGroup) {
          return false;
        } else {
          return true;
        }
      }
    },
    shenqing(item) {
      this.$api.social
        .InsertGroup({
          groupId: item.id,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "已申請入群，請耐心等待",
            });
          } else {
            this.$message.error({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
    async getGroupList() {
      let groupRes = null;
      if (this.loginUser) {
        groupRes = await this.$api.social.GetMyGroupList({
          SkipCount: 0,
          MaxResultCount: 999,
        });
      }
      this.$api.social
        .FindGroupByUsersId({
          usersId: this.authorId,
          SkipCount:
            (this.pageParamsGroup.currentPage - 1) * this.pageParamsGroup.limit, //从第几条开始查，
          MaxResultCount: this.pageParamsGroup.limit, //查多少条
        })
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            res.data.result.items.forEach((item) => {
              if (groupRes !== null) {
                const info = groupRes.data.result.items.find(
                  (c) => c.id === item.id
                );
                if (info) {
                  item.inGroup = true;
                } else {
                  item.inGroup = false;
                }
              } else {
                item.inGroup = false;
              }
            });
            this.groupList = res.data.result.items;
            if (res.data.result.items <= 0) {
              this.dataList = false;
            }
            this.pageParamsGroup.total = res.data.result.totalCount;
            if (this.pageParamsGroup.total >= 1) {
              this.pageParamsGroup.pageshow = true;
            }
          }
        });
    },
    getAuthorInfo() {
      let params = {
        id: this.authorId,
      };
      this.$api.common.GetUserInfoById(params).then((res) => {
        this.authorLogo = res.data.result.userLogoBig;
        this.authorName = res.data.result.sgL_UsersName;
        document.title = `${res.data.result.sgL_UsersName} - 相簿一覽`;
      });
    },
    getPicturePublish() {
      this.dataList = true;
      let params = {
        SGL_PG_CName: this.title,
        SGL_Mem_Cid: this.authorId,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.albumApi
        .getPicturePublishLook(params)
        .then((res) => {
          if (res.data.success) {
            this.floading = false;
            this.albumList = res.data.result.items;
            if (this.albumList.length <= 0) {
              this.dataList = false;
            }
            this.pageParams.total = res.data.result.totalCount;
            if (this.pageParams.total >= 1) {
              this.pageParams.pageshow = true;
            }
          } else {
            this.dataList = false;
          }
        })
        .catch((re) => {
          this.dataList = false;
        });
    },
    getVideoAndMovieCount() {
      let params = {
        SGL_Mem_Cid: this.authorId,
      };
      this.$api.VideoApi.getVideoAndMovieCountByUser(params).then((res) => {
        if (res.data.success) {
          this.countList = res.data.result;
        }
      });
    },
    getVideoPublish() {
      let params = {
        Title: this.title,
        SGL_Mem_Cid: this.authorId,
        SkipCount:
          (this.pageParamsVideo.currentPage - 1) * this.pageParamsVideo.limit, //从第几条开始查，
        MaxResultCount: this.pageParamsVideo.limit, //查多少条
      };
      this.$api.VideoApi.GetMovieTypeListById(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          this.videoList = res.data.result.items;
          if (res.data.result.items <= 0) {
            this.dataList = false;
          }
          this.pageParamsVideo.total = res.data.result.totalCount;
          if (this.pageParamsVideo.total >= 1) {
            this.pageParamsVideo.pageshow = true;
          }
        }
      });
    },
    showContent(type) {
      this.isPicture = type;
      if (this.isPicture == 0) {
        this.getPicturePublish();
      } else if (this.isPicture == 1) {
        this.getVideoPublish();
      }
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getPicturePublish();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getPicturePublish();
    },
    //分页的方法
    handleCurrentChangevideo(val) {
      this.pageParamsvideo.currentPage = val;
      this.getVideoPublish();
    },
    handleSizeChangevideo(val) {
      this.pageParamsvideo.limit = val;
      this.pageParamsvideo.currentPage = 1;
      this.getVideoPublish();
    },
    //分页的方法
    handleCurrentChangeGroup(val) {
      this.pageParamsGroup.currentPage = val;
      this.getGroupList();
    },
    handleSizeChangeGroup(val) {
      this.pageParamsGroup.limit = val;
      this.pageParamsGroup.currentPage = 1;
      this.getGroupList();
    },
  },
  computed: {
    sortLink() {
      return this.getSortLink(this.authorId, "A");
    },
    getPageShow() {
      return this.pageParams.pageshow;
    },
    getPageShowvideo() {
      return this.pageParamsvideo.pageshow;
    },
    getPageShowGroup() {
      return this.pageParamsGroup.pageshow;
    },
    getalbumList() {
      if (this.albumList == null || this.albumList.length == 0) {
        return true;
      } else {
        return false;
      }
    },

    getvideoList() {
      if (this.videoList == null || this.videoList.length == 0) {
        return true;
      } else {
        return false;
      }
    },

    getGroup() {
      if (this.groupList == null || this.groupList.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.notclick {
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer/customerPublishLook.vue